import swal from "@/CommonVueCore/src/assets/js/vendor/notifications/sweet_alert.min";

export class SweetAlertService {
  constructor({ defaultOptions = {} }) {
    this.defaultOptions = {
      buttonsStyling: false,
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-light",
        denyButton: "btn btn-light",
        input: "form-control",
        title: "swal-title-custom",
        htmlContainer: "swal-content-custom",
      },
      ...defaultOptions,
    };
    this.swalInit = swal.mixin(this.defaultOptions);
  }

  fireCustom(options) {
    const largeButtons = options.largeButtons ? " btn-touch" : "";

    const mergedOptions = {
      ...this.defaultOptions,
      ...options,
      customClass: {
        ...this.defaultOptions.customClass,
        ...options.customClass,
        confirmButton:
          (options.customClass?.confirmButton || this.defaultOptions.customClass.confirmButton) + largeButtons,
        cancelButton:
          (options.customClass?.cancelButton || this.defaultOptions.customClass.cancelButton) + largeButtons,
        denyButton:
          (options.customClass?.denyButton || this.defaultOptions.customClass.denyButton) + largeButtons,
      },
    };

    return this.swalInit.fire({
      ...mergedOptions,
      html: mergedOptions.html || "",
    });
  }

  success(title, text, customOptions = {}) {
    return this.fireCustom({
      title: title,
      text: text,
      icon: "success",
      width: customOptions.width || "700px",
      ...customOptions,
    });
  }

  info(title, text, customOptions = {}) {
    return this.fireCustom({
      title: title,
      text: text,
      icon: "info",
      width: customOptions.width || "700px",
      ...customOptions,
    });
  }

  warning(title, text, customOptions = {}) {
    return this.fireCustom({
      title: title,
      text: text,
      icon: "warning",
      width: customOptions.width || "700px",
      ...customOptions,
    });
  }

  error(title, text, customOptions = {}) {
    return this.fireCustom({
      title: title,
      text: text,
      icon: "error",
      width: customOptions.width || "700px",
      ...customOptions,
    });
  }

  question(title, htmlContent, customOptions = {}) {
    return this.fireCustom({
      title: title,
      html: htmlContent,
      icon: "question",
      width: customOptions.width || "700px",
      ...customOptions,
    });
  }
}
